export enum PerfilTipoEnum {
  EMPRESA = 'EMPRESA',
  ADVOGADO = 'ADVOGADO',
  JUDCLASS = 'JUDCLASS',

}
